import {Component, OnInit, ViewChild, Optional, ViewContainerRef} from '@angular/core';
import {UserWebIosService} from '../../_services/user-web-ios.service';
import {DataTableDirective} from 'angular-datatables';

@Component({
    selector: 'app-user-web-ios',
    templateUrl: './user-web-ios.component.html',
    styleUrls: ['./user-web-ios.component.css']
})
export class UserWebIosComponent implements OnInit {

    searchWord: string;
    delayTimer: any;
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;

    //declare parameters object
    parameters: any = {};
    //declare callback object
    callback: any = {};
    filterBy = 2; // default get all user

    constructor(private userWebIosService: UserWebIosService) {
    }

    ngOnInit() {
        this.registerTable();
        if ($('.content-wrapper').height() < 838) {
            $('.content-wrapper').css('min-height', 838);
        }
    }

    registerTable() {
        let self = this;
        this.dtOptions = {
            language: {
                emptyTable: "データが存在しません"
            },
            order: [[0, "desc"]],
            searching: false,
            lengthChange: false,
            serverSide: true,
            pageLength: 15,
            ajax: function (parameters, callback, settings) {
                parameters["search"]["value"] = self.searchWord || '';

                if (self.filterBy == 1) {
                    parameters["search"]["filter"] = 1;
                } else if (self.filterBy == 0) {
                    parameters["search"]["filter"] = 0;
                }

                //assign parameters object
                self.parameters = parameters;

                //assign callback object
                self.callback = callback;

                self.userWebIosService.gets(parameters).subscribe(result => {
                    callback({
                        draw: parameters['draw'],
                        data: result.data,
                        recordsTotal: result.data.length,
                        recordsFiltered: result.recordsTotal
                    });
                });
            },
            columns: [
                {
                    title: "ID",
                    data: "id",
                    name: "id",
                    className: "all text-justify"
                },
                {
                    title: "ユーザー名",
                    data: "username",
                    name: "username",
                    className: "all text-justify"
                },
                {
                    title: "メール",
                    data: "email",
                    name: "email",
                    className: "text-justify"
                },
                {
                    title: "モジュール名",
                    data: "module_name",
                    name: "module_name",
                    className: "text-justify"
                },
                {
                    title: "",
                    data: "btn_is_active_module",
                    width: '60px',
                    className: "all text-center",
                    orderable: false
                },
            ],
            rowCallback: (row: Node, data: any[] | Object, index: number) => {
                const self = this;
                $('.btn-is-active', row).bind('click', () => {
                    self.IsAdminApproved(data);
                });

                if (data['is_active_module'] == 0) {
                    $(row).css('background-color', '#3c8dbc');
                    var btn_active_bot = $(row).find('td').find('.btn-active-module');
                    btn_active_bot.css({
                        'background-color': 'HotPink',
                        'border-color': 'HotPink'
                    });
                    btn_active_bot.mouseover(function () {
                        btn_active_bot.css('opacity', '0.8');
                    });
                    btn_active_bot.mouseout(function () {
                        btn_active_bot.css('opacity', '1');
                    });
                }

                return row;
            }
        };
    }

    valuechange(newValue) {
        this.searchWord = newValue;
        this.doSearch();
    }

    doSearch() {
        let self = this;
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(function () {
            self.rerenderDataTable();
        }, 600); // Will do the ajax stuff aft
    };

    onChangeFilter(event) {
        this.filterBy = event.target.value;
        this.rerenderDataTable();
    }

    rerenderDataTable(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }

    loadCurrentPage() {
        //get parameters and retrive result of current page 
        this.userWebIosService.gets(this.parameters).subscribe(result => {
            //use callback function
            this.callback({
                //retrive draw current
                draw: this.parameters['draw'],
                //retrive data of current page
                data: result.data,
                //retrive number records per page
                recordsTotal: result.data.length,
                //retrive total records
                recordsFiltered: result.recordsTotal
            });
        });
    }

    IsAdminApproved(data) {
        this.userWebIosService.activeModules(data).subscribe(data => {
            if (!data.error) {
                this.loadCurrentPage();
            } else {
                alert(data.message);
            }
        }, error => {
            alert(error.json().message);
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/user-web-ios/user-web-ios.component.ts